var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon36Vk = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.89795 6.64795C5 8.5459 5 11.6006 5 17.71V18.79C5 24.8994 5 27.9541 6.89795 29.8521C8.79589 31.75 11.8506 31.75 17.96 31.75H19.04C25.1494 31.75 28.2041 31.75 30.1021 29.8521C32 27.9541 32 24.8994 32 18.79V17.71C32 11.6006 32 8.5459 30.1021 6.64795C28.2041 4.75 25.1494 4.75 19.04 4.75H17.96C11.8506 4.75 8.79589 4.75 6.89795 6.64795ZM9.5 13C9.64454 20.0234 13.3336 24.25 19.4142 24.25H19.7669V20.232C21.9815 20.4568 23.6329 22.1124 24.3071 24.25H27.5C26.6338 21.0522 24.388 19.2842 22.9922 18.6088C24.3869 17.7734 26.3609 15.7482 26.8258 13H23.9209C23.3115 15.2349 21.4982 17.2601 19.7658 17.4524V13H16.8146V20.795C15.0186 20.3455 12.6756 18.1592 12.5796 13H9.5Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon36Vk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon36Vk.d6d903d70820ea9fda92e08053e3210b.svg";